import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from '../generic.service';

/** Used when ADDING a new direct application record. */
export interface StudentDirectApplicationRequest {
  studentId: string;
  instituteId: string;
  courseLevel?: number | null;
  courseId?: number | null;
  inTakeYear: string;
}

/** Used when LISTING direct applications for a student (POST /api/directapplication). */
export interface GetStudentDirectApplicationRequest {
  studentId: string;
  status?: number | null;
}


export interface MilestoneAttachment {
  attachmentUrl?: string | null;
  createdDate?: string | null;
}

export interface MilestoneResponse {
  id: number;
  studentId: string;
  counsellorId: string;
  studentDirectApplicationId: number;
  remarks?: string | null;
  applicationStatus: number;
  applicationStatusDescription?: string | null;
  attachment?: (string | MilestoneAttachment)[] | null;
  internalTeamNotes?: string | null;
  createdOn?: string | null;
  updatedOn?: string | null;
}

export interface EnumOption {
  value: number;
  label: string;
}

export interface StatusOptionsResponse {
  applicationStatuses: EnumOption[];
  offerStatuses: EnumOption[];
}

@Injectable({
  providedIn: 'root'
})
export class StudentDirectApplicationService {

  constructor(private genericService: GenericService) { }

  getByStudentId(req: GetStudentDirectApplicationRequest): Observable<any> {
    return this.genericService.post(`directapplication`, req);
  }

  addStudentDirectApplication(req: StudentDirectApplicationRequest): Observable<any> {
    return this.genericService.post(`studentdirectapplication`, req);
  }

  deleteStudentDirectApplication(id: number): Observable<any> {
    return this.genericService.delete(`studentdirectapplication/${id}`);
  }

  
  getMilestones(studentId: string): Observable<any> {
    return this.genericService.get(`studentdirectapplication/milestone/${studentId}`);
  }

 
  addMilestone(formData: FormData): Observable<any> {
    return this.genericService.postFormData<any>(`studentdirectapplication/milestone`, formData);
  }

 
  updateMilestone(formData: FormData): Observable<any> {
    return this.genericService.putFormData<any>(`studentdirectapplication/milestone`, formData);
  }

  /** Fetch Application + Offer (Decision) status option listings from the API. */
  getStatusOptions(): Observable<any> {
    return this.genericService.get(`studentdirectapplication/status-options`);
  }

  /** Update an application's status. */
  updateApplicationStatus(req: { studentDirectApplicationId: number; status: number }): Observable<any> {
    return this.genericService.patch(`studentdirectapplication/status`, req);
  }

  /** Update an application's offer (decision) status. */
  updateOfferStatus(req: { studentDirectApplicationId: number; offerStatus: number }): Observable<any> {
    return this.genericService.patch(`studentdirectapplication/offerstatus`, req);
  }
}
